import { useState, useCallback, useEffect } from 'react';
import apiService from '../services/apiService';

function useApi(endpoint, method = 'get', body = null, responseType = 'json') {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async (dynamicEndpoint, dynamicMethod = method, dynamicBody = body) => {
    const targetEndpoint = dynamicEndpoint || endpoint;
    if (!targetEndpoint) return null;
    setLoading(true);
    setError(null);
    try {
      let response;
      if (responseType === 'blob') {
        response = await apiService.getBlob(targetEndpoint);
      } else {
        response = await apiService[dynamicMethod](targetEndpoint, dynamicBody);
      }
      setData(response);
      return response;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        // Token expired or invalid, signal logout
        setError('Session expired. Please log in again.');
        throw new Error('Session expired');
      }
      setError(err.message || 'Request failed');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [endpoint, method, body, responseType]);

  useEffect(() => {
    if (endpoint && responseType !== 'blob') {
      fetchData();
    }
  }, [fetchData, endpoint, responseType]);

  return { data, loading, error, fetchData };
}

export default useApi;